import { styled } from '@mui/material/styles';

export const ImageWrapper = styled('div')(() => ({
  height: 180,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
